import React from "react";

import { PALETTE } from "../../common/ThemeConstants";
import { AdminTabsList } from "../constants";
import { Col, Container, Row } from "react-bootstrap";
import NavLinkButton from "../../common/components/NavLinkButton";

export default function AdminTabs() {
  return (
    <Container>
      <Row
        className="text-center d-flex flex-nowrap m-auto"
        style={{
          paddingBottom: 10,
          height: "fit-content",
          maxWidth: "100%",
          overflowX: "auto",
        }}
      >
        {AdminTabsList.map((tab, idx) => (
          <Col key={idx} className="m-auto text-center py-2 mt-2">
            <NavLinkButton
              text={tab.name}
              to={tab.to}
              backgroundColor={PALETTE.LIGHTGRAY}
              borderColor={PALETTE.LIGHTGRAY}
              color={PALETTE.GRAY}
              backgroundColorHover={PALETTE.KINDALIGHTGRAY}
              colorHover={PALETTE.SECONDARYCOLORHOVER}
              px
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
}
